import React from "react";
import { withRouter } from "react-router";

import { withItemsIntellegence } from "../../../shared/containers/containerItemsIntellegence";
import { withTimerangeIntelligence } from "../../../shared/containers/containerTimerangeIntelligence";
import { withIntelligenceDateControls } from "./../../../shared/containers/containerIntelligenceDateControls";

import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";
import { states } from "../../../reducers/queriesStates";
import { withChartSensors } from "../../../shared/containers/containerChartSensors";
import { withReportsList } from "../../../shared/containers/containerReportsList";

const getIntellegenceData = (props) => {
  const {  rangeStartDate, rangeEndDate, rangeStartTime, rangeEndTime, onCloseIntelligenceDateControls } = props;

  const startDate = new Date(rangeStartDate);
  const startTime = new Date(rangeStartTime);
  startDate.setHours(startTime.getHours());
  startDate.setMinutes(startTime.getMinutes());

  const endDate = new Date(rangeEndDate);
  const endTime = new Date(rangeEndTime);
  endDate.setHours(endTime.getHours());
  endDate.setMinutes(endTime.getMinutes());
  endDate.setSeconds(59);

  const { onGetChartSensors, reportsListData, unitId } = props;

  const chartReport = reportsListData.filter((item) => {
    return item.buildType === 2;
  })[0];

  onGetChartSensors(
    {
      carId: unitId,
      startDate,
      endDate,
    },
    chartReport
  );

  //onCloseIntelligenceDateControls();
};

const ChartSensorsButtonWrapper = (props) => {
  const { disabled, chartSensorsDataState } = props;

  return (
    <ButtonPrimary
      handleClick={getIntellegenceData.bind(this, props)}
      title="Показать"
      disabled={disabled || chartSensorsDataState === states.REQUEST ? true : false}
    />
  );
};

export default withChartSensors(
  withReportsList(
    withTimerangeIntelligence(withIntelligenceDateControls(withItemsIntellegence(withRouter(React.memo(ChartSensorsButtonWrapper)))))
  )
);
